<template>
    <div class="event-gallery">
        <h3>{{ $t('profiles.titles.galery') }}</h3>
        <carousel
            class="carousel fixed-carousel-arrows"
            :wrap-around="false"
            :transition="500"
            :breakpoints="{
                0: {
                itemsToShow: 1,
                snapAlign: 'start'
                },
                700: {
                itemsToShow: 1.5,
                snapAlign: 'start'
                },
                1000: {
                itemsToShow: 2,
                snapAlign: 'start'
                },
                1350: {
                itemsToShow: 2.5,
                snapAlign: 'start'
                },
                1700: {
                itemsToShow: 3,
                snapAlign: 'start'
                },
                2050: {
                itemsToShow: 3.5,
                snapAlign: 'start'
                }
            }"
          >
            <slide v-for="item in vaildMedias" :key="item.id" class="p-2">
              <img
                v-if="item.type === 1"
                :src="getVideoImagePreview(item.video_url)"
                :alt="item.name"
                class="cursor-pointer"
                loading="lazy"
                @click="
                  openPreviewModal(IMAGE_PREVIEW, {
                    video: item.video_url,
                    title: item.name
                  })
                "
              />
              <img
                v-else
                :src="
                  item.thumbnails.s_cd ||
                    require('@/assets/images/placeholder-gallery.svg')
                "
                class="cursor-pointer"
                loading="lazy"
                @click="
                  openPreviewModal(IMAGE_PREVIEW, {
                    img:
                      item.thumbnails.l_dt ||
                      require('@/assets/images/placeholder-gallery.svg'),
                    title: item.name
                  })
                "
                @error="
                  $event.target.src = require('@/assets/images/placeholder-gallery.svg')
                "
              />
            </slide>
            <template #addons>
              <navigation />
            </template>
          </carousel>
    </div>
</template>

<script setup>
import { useEvent } from "@/composables/useEvent";
import { useModalHandler } from "@/plugins/useModalHandler";
import { Carousel, Navigation, Slide } from "vue3-carousel";

const { 
    // details:event,
    vaildMedias
} = useEvent();
const {
  IMAGE_PREVIEW,
  openPreviewModal
} = useModalHandler();

const getVideoImagePreview = url => {
  let id = url?.match(/\/embed\/\w{11}/);
  if (!id?.length) return;
  id = id[0].replace("/embed/", "");
  return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
};

</script>

<style lang="scss" scoped>
.event-gallery{
    margin-left: auto;
    margin-right: auto;
    max-width: $maxWidthEventGallery;
    width: 100%;
    height: auto;
    background-color: $infoCardColor;
    border-radius: 24px;
    padding: 12px;
    margin-top: 8px;
    h3 {
        font-size: $galleryTitleSize;
        color: $galleryTitleColor;
    }
    img {
        height: -webkit-fill-available;
        object-fit: cover;
    }
}
</style>
